import { useState } from 'react';
import JunoForm from '../common/JunoForm';
import { testEmailRule, useJunoCommonFunctions } from '../../../client/Juno/helpers';
import { useSelector } from 'react-redux';
import { apiService } from '../../../client/common/apiCallService';

const AddAccounts = ({ getClientUsers, onClose, account, handleUpdateUser, isEdit }) => {
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();
    const [form, setForm] = useState({
        email: account?.clientEmail || '',
        password: '',
        confirm: '',
        read: account?.readOnly ? 'yes' : 'no',
    });

    const [errors, setErrors] = useState({});
    const clientData = useSelector(state => state.juno.clientData);
    const apiUrl = useSelector(state => state.config.api_url);
    const [loading, setLoading] = useState(false);

    const fields = [
        {
            label: 'client account email',
            name: 'email',
            value: form.email,
            placeholder: 'enter account email',
            isRequired: !isEdit,
        },
        {
            label: 'password',
            name: 'password',
            type: form.showNew ? 'text' : 'password',
            value: form.password,
            placeholder: 'create password',
            visibileIcon: true,
            visibilityKey: 'showNew',
            isRequired: !isEdit,
        },
        {
            label: 'confirm password',
            name: 'confirm',
            type: form.showConfirm ? 'text' : 'password',
            value: form.confirm,
            placeholder: 'confirm password',
            visibileIcon: true,
            visibilityKey: 'showConfirm',
            isRequired: !isEdit,
        },
        {
            label: 'read only',
            name: 'read',
            value: form.read,
            type: 'select',
            placeholder: 'select state',
            options: ['Yes', 'No'],
        },
    ];

    const handleChange = (event = {}, op, field, selected) => {
        if (op == 'bool' || op == 'select') {
            return setForm(prev => ({
                ...prev,
                [field]: selected || !prev[field],
            }));
        }

        const { name, value } = event.target;

        if (errors) {
            setErrors(null);
        }

        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSave = () => {
        let errorObj = {};

        if (!form.email) {
            errorObj.email = 'Email is a required.';
        } else if (!testEmailRule(form.email)) {
            errorObj.email = 'Invalid email format.';
        }

        if (!form.password && !isEdit) {
            errorObj.password = 'Password is required.';
        }

        if (!form.confirm && !isEdit) {
            errorObj.confirm = 'Confirm password is required.';
        }

        if ((form.confirm || form.password) && form.confirm != form.password) {
            errorObj.confirm = 'Passwords do not match.';
        }

        if (Object.keys(errorObj).length) {
            setErrors(errorObj);
        } else {
            if (isEdit) {
                return handleUpdateUser(
                    {
                        updateEmail: account?.clientEmail || form.email,
                        clientEmail: form.email,
                        password: form.password,
                        readOnly: form.read?.toLowerCase() == 'yes',
                    },
                    'updateForm',
                );
            }

            setLoading(true);
            const payload = {
                clientEmail: form.email,
                password: form.password,
                readOnly: form.read == 'Yes',
                parentClient: clientData._id,
            };
            if (clientData) {
                apiService(
                    (window.location.hostname === 'localhost' ? apiUrl : '') +
                        '/restapi/create-client-associated-user',
                    {
                        ...payload,
                    },
                    async data => {
                        if (data) {
                            setLoading(false);
                            getClientUsers();
                            onClose();
                        }
                    },
                    err => {
                        console.log(err);
                        setErrors({ email: err });
                        setLoading(false);
                    },
                );
            }
        }
    };

    return (
        <JunoForm
            fields={fields}
            formData={form}
            bottomText={isEdit ? 'save' : 'add aditional account'}
            buttonClassName={`mt-12 font-medium ${windowWidth < 768 && 'absolute bottom-10'}`}
            handleChange={handleChange}
            onBottomClick={handleSave}
            errors={errors}
            loading={loading}
        />
    );
};

export default AddAccounts;
